import { requireSupabase, supabase } from "./supabase";

export interface AllowedUser {
  email: string;
  active: boolean;
  createdAt: string;
  consumedAt?: string;
}

interface AllowedUserRow {
  email: string;
  active: boolean;
  created_at: string;
  consumed_at: string | null;
}

export function normalizeInviteEmail(email: string) {
  return email.trim().toLowerCase();
}

export function validateInviteEmail(email: string) {
  const normalized = normalizeInviteEmail(email);
  if (!normalized || normalized.length > 320 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
    return "Saisissez une adresse électronique valide.";
  }
  return "";
}

export function invitationState(invitation: AllowedUser) {
  if (!invitation.active) return "revoked";
  return invitation.consumedAt ? "joined" : "pending";
}

export async function getAdminStatus() {
  if (!supabase) return false;
  const { data, error } = await supabase.rpc("is_app_admin");
  if (error) throw error;
  return data === true;
}

export async function listAllowedUsers(): Promise<AllowedUser[]> {
  const client = requireSupabase();
  const { data, error } = await client.rpc("admin_list_allowed_users");
  if (error) throw error;
  return ((data ?? []) as AllowedUserRow[]).map((row) => ({
    email: row.email,
    active: row.active,
    createdAt: row.created_at,
    consumedAt: row.consumed_at ?? undefined,
  }));
}

export async function inviteAllowedUser(email: string) {
  const normalized = normalizeInviteEmail(email);
  const validationError = validateInviteEmail(normalized);
  if (validationError) throw new Error(validationError);
  const { error } = await requireSupabase().rpc("admin_invite_user", { invited_email: normalized });
  if (error) throw error;
}

export async function setAllowedUserActive(email: string, active: boolean) {
  const { error } = await requireSupabase().rpc("admin_set_allowed_user_active", {
    target_email: normalizeInviteEmail(email),
    target_active: active,
  });
  if (error) throw error;
}
